<div class="dgh-print-paper-container" #printTemplate>
    <div class="dgh-print-paper--static">
        <div class="sh-template-stack">
            <h4 class="sh-template-stack__item">{{ this.titleTranslationKey | translate }}</h4>
            <digihaven-record-overview
                class="sh-template-stack__item"
                [standalonePage]="false"
                [condensed]="true"
                [columns]="columns"
                [query]="query"
                [sort]="sort"
                [titleMapperFn]="mapCountToTitle"
                [defaultPageSize]="amountOfRecords"
                (recordsPagedResult)="recordsLoaded($event)"
            ></digihaven-record-overview>
        </div>
    </div>
</div>
